import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneSimpleBotSpeech.styl';


/**
 * @emits onClickChangePhone {} - клик по кнопке изменить phone
 */
Vue.component('BXmakerAuthuserphoneSimpleBotSpeech',
    {
        props: [

        ],
        data: function () {
            return {
                //последняя операция была - проверка?
                // для повторения операции после ввода капчи - при необходимости
                lastActionCheck: false,
            };
        },
        mounted() {
            this.$refs.refInputCode.focus();
        },
        computed: {

        },
        methods: {
            onInputCode(value) {
                this.$root.setBotSpeechCode(value);
                if (this.$root.botSpeechLength === value.length) {
                    this.onClickCheck();
                }
            },
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.authByPhone();
            },
            onClickChangePhone() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.setBotSpeechCode('');
                this.$root.startConfirmBotSpeech();

            },
            onCompleteCaptcha() {
                //повторяем операцию последнюю
                if (!this.lastActionCheck) {
                    this.onClickStart();
                    return;
                }

                //повторяем операцию последнюю
                if (this.$root.botSpeechLength !== this.$root.botSpeechCode.length) {
                    return;
                }

                this.onClickCheck();
            },
            onCompleteTimeout() {
                this.$root.setBotSpeechTimeout(0);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-simple-botspeech"  >
            
                <slot name="header">
                    <BXmakerAuthuserphoneHeader>
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_TITLE}}
                    </BXmakerAuthuserphoneHeader>     
                </slot>
                
                <slot name="message">
                    <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />     
                </slot>                
                    
                <slot name="notice">
                    <div class="bxmaker-authuserphone-simple-botspeech__notice">
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_NOTICE}}
                         
                         <span class="bxmaker-authuserphone-simple-botspeech__phone">{{$root.formattedPhone}}</span>
                         
                         <BXmakerAuthuserphoneLink @onClick="onClickChangePhone">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_CHANGE_PHONE}}
                         </BXmakerAuthuserphoneLink>                     
                    </div>
                </slot>
                
                <slot name="code">
                    <BXmakerAuthuserphoneInputCode 
                        :value="$root.botSpeechCode" 
                        @onInput="onInputCode" 
                        @onEnter="onClickCheck" 
                        ref="refInputCode" 
                        :maxLength="$root.botSpeechLength"  
                        :loader="$root.botSpeechCheckLoader"
                    />
                </slot>
                               
                <slot name="captcha">
                    <BXmakerAuthuserphoneCaptcha 
                        :code="$root.captchaCode"
                        :src="$root.captchaSrc"
                        :length="$root.captchaLength"
                        :loader="$root.captchaLoader"
                        @onInput="$root.setCaptchaCode"
                        @onComplete="onCompleteCaptcha"
                        @onRefresh="$root.refreshCaptcha"
                   />  
                </slot>                                                        
                
                <slot name="timeout">
                    <BXmakerAuthuserphoneTimeout 
                    :timeout="$root.botSpeechTimeout"
                     v-if="$root.botSpeechTimeout"
                     @onComplete="onCompleteTimeout" >  
                        <template v-slot:before>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_TIMEOUT_TITLE}} <br>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_TIMEOUT_SUBTITLE}} 
                        </template>       
                     </BXmakerAuthuserphoneTimeout>  
                 </slot>             
                            
                <slot name="request"  v-if="!$root.botSpeechTimeout">                
                    <div class="bxmaker-authuserphone-simple-botspeech__send"  >
                        <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.botSpeechStartLoader">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_BOT_SPEECH_GET_NEW}}   
                         </BXmakerAuthuserphoneLink> 
                         <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-simple-botspeech__send-loader" v-else />
                    </div>  
                </slot>              
                                
            </div>
        `,
    });